import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect1',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('login.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/403',
    component: () => import('@/views/Error/403.vue'),
    name: 'Forbidden',
    meta: {
      hidden: true,
      title: '403',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/dashboard',
    component: Layout,
    name: 'Dashboard',
    meta: {
      title: '仪表板',
      icon: 'bx:bxs-component',
    },
    children:[
      {
        path: '',
        component: () => import('@/views/Dashboard/index.vue'),
        name: 'DashboardIndex',
        meta: {
          title: '仪表板',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
  {
    path: '/display',
    component: Layout,
    name: 'Display',
    meta: {
      title: '仪表板',
      icon: 'bx:bxs-component',
      hidden: true
    },
    children:[{
        path: '',
        component: () => import('@/views/Dashboard/Edit.vue'),
        name: 'DashboardDisplay',
        meta: {
          title: '仪表板',
          noCache: true,
          affix: true,
          hideBreadcrumb:false,
          hidden: true
        }      
    }]
  },
  {
    path: '/preview',
    component: Layout,
    name: 'Preview',
    meta: {
      title: '仪表板',
      icon: 'bx:bxs-component',
      hidden: true
    },
    children:[{
        path: '',
        component: () => import('@/views/Dashboard/Preview.vue'),
        name: 'DashboardPreview',
        meta: {
          title: '仪表板',
          noCache: true,
          affix: true,
          hideBreadcrumb:false,
          hidden: true
        }      
    }]
  },      
  {
    path: '/edit',
    component: Layout,
    // redirect: '/dashboard',
    name: 'Edit',
    meta: {
      title: '仪表板',
      icon: 'bx:bxs-component',
      hidden: true
    },
    children:[
      {
        path: '',
        component: () => import('@/views/Dashboard/Edit.vue'),
        name: 'DashboardEdit',
        meta: {
          title: '仪表板',
          noCache: true,
          affix: true,
          hideBreadcrumb:false,
          hidden: true,
          activeMenu: '/dashboard',
          activeMenuName:'Dashboard'
        }
      },
    ]
  },
  {
    path: '/report',
    redirect: '/report/web',
    component: Layout,
    name: 'Report',
    meta: {
      title: '报表',
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children:[
      {
        path: 'web',
        component: () => import('@/views/Reports/Web/index.vue'),
        name: 'WebReport',
        meta: {
          title: '仪表板报表',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        },
        children:[
          {
            path: 'edit',
            component: () => import('@/views/Reports/Web/edit.vue'),
            name: 'WebReportEdit',
            meta: {
              title: '仪表板报表',
              noCache: true,
              affix: true,
              hideBreadcrumb:false
            }
          }
        ]
      },
      {
        path: 'web/display',
        component: () => import('@/views/Reports/Web/edit.vue'),
        name: 'WebReportDisplay',
        meta: {
          title: '仪表板报表',
          noCache: true,
          affix: true,
          hideBreadcrumb:false,
          hidden:true,
        }
      },
      {
        path: 'web/export',
        component: () => import('@/views/Reports/Web/export.vue'),
        name: 'WebReportExport',
        meta: {
          hidden: true,
          title: '仪表板报表',
          noCache: true,
          affix: true,
          hideBreadcrumb:false,
        }
      },
      {
        path: 'doc',
        component: () => import('@/views/Reports/Doc/index.vue'),
        name: 'DocReport',
        meta: {
          title: '文档报表',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
      {
        path: 'doc/temp/edit',
        component: () => import('@/views/Reports/Doc/tempEdit.vue'),
        name: 'DocReportTempEdit',
        meta: {
          hidden: true,
          title: '文档报表',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
      {
        path: 'doc/report/edit',
        component: () => import('@/views/Reports/Doc/reportEdit.vue'),
        name: 'DocReportEdit',
        meta: {
          hidden: true,
          title: '文档报表',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
      {
        path: 'doc/report/display',
        component: () => import('@/views/Reports/Doc/reportEdit.vue'),
        name: 'DocReportDisplay',
        meta: {
          hidden: true,
          title: '文档报表',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
      {
        path: 'doc/report/export',
        component: () => import('@/views/Reports/Doc/reportExport.vue'),
        name: 'DocReportExport',
        meta: {
          hidden: true,
          title: '文档报表',
          noCache: true,
          affix: true,
          hideBreadcrumb:false,
        }
      },
    ]
  },
  {
    path: '/components/basic',
    component: Layout,
    // redirect: '/dashboard',
    name: 'BasicComponents',
    meta: {
      title: '基础组件库',
      icon: 'bx:bxs-component',
    },
    children:[
      {
        path: '',
        component: () => import('@/views/ComponentsLib/basic.vue'),
        name: 'BasicComponentsIndex',
        meta: {
          title: '基础组件库',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
  {
    path: '/components/features',
    component: Layout,
    // redirect: '/dashboard',
    name: 'FeatureComponents',
    meta: {
      title: '功能组件库',
      icon: 'bx:bxs-component',
    },
    children:[
      {
        path: 'features',
        component: () => import('@/views/ComponentsLib/features.vue'),
        name: 'FeatureComponentsIndex',
        meta: {
          title: '功能组件库',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
  {
    path: '/filter',
    component: Layout,
    name: 'Filter',
    meta: {
      title: '筛选器',
      icon: 'bx:bxs-component',
    },
    children:[
      {
        path: '',
        component: () => import('@/views/QueryFilter/index.vue'),
        name: 'FilterIndex',
        meta: {
          title: '筛选器',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
  {
    path: '/datasources',
    component: Layout,
    // redirect: '/dashboard',
    name: 'Datasources',
    meta: {
      title: '数据源',
      icon: 'bx:bxs-component',
    },
    children:[
      {
        path: '',
        component: () => import('@/views/DataSource/index.vue'),
        name: 'DataSourcesIndex',
        meta: {
          title: '数据源',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
